import { Pipe, PipeTransform, inject } from '@angular/core';
import { LangFacade } from '@library/store/lang/lang.facade';
import { Observable } from 'rxjs';

@Pipe({
  name: 'AsyncLang',
  standalone: false,
})
export class AsyncLangPipe implements PipeTransform {
  private readonly langFacade = inject(LangFacade);

  transform(value: string, args: string[] = []): Observable<string> {
    return this.langFacade.translate(value, args);
  }
}
